module.exports = __webpack_public_path__ + "img/elaqat.b47fd5a1.svg";